import { useState } from 'react'
import { PluginState } from '@/components/Plugins/types'
import {PluginTypes} from '@/types/plugins'


const usePlugin = () => {
  const [pluginState, setPlugin] = useState<PluginState>({
    current: undefined,
    words: '', // 选中的词
  })
  const setCurrent = (current: PluginTypes | undefined) => {
    setPlugin({
      ...pluginState,
      current
    })
  }
  const setCurrentAndWords = (current: PluginTypes | undefined, words: string | undefined) => {
    setPlugin({
      ...pluginState,
      current,
      words
    })
  }

  const setPluginState = (current: PluginTypes) => {
    setPlugin({
      ...pluginState,
      current
    })
  }
  return {
    pluginState,
    setCurrent,
    setCurrentAndWords,
    setPluginState
  }
}

export default usePlugin
